import { render, staticRenderFns } from "./NpaPromotionHistoryAdd.vue?vue&type=template&id=30a8f406&scoped=true&"
import script from "./NpaPromotionHistoryAdd.vue?vue&type=script&lang=js&"
export * from "./NpaPromotionHistoryAdd.vue?vue&type=script&lang=js&"
import style0 from "./NpaPromotionHistoryAdd.vue?vue&type=style&index=0&id=30a8f406&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a8f406",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCard,VDatePicker,VDialog,VFileInput,VForm,VIcon,VMenu,VSelect,VTextField,VTextarea})
